import { RESERVATION_CLEAR, RESERVATION_FETCH_SUCCESS } from '../actions/reservationActions.js';

const initialState = {
  loaded: false,
  data: null
};

export default function reservationReducer(state = initialState, action) {
  switch (action.type) {
    case RESERVATION_FETCH_SUCCESS:
      return {
        ...state,
        loaded: true,
        data: action.payload.result
      };

    case RESERVATION_CLEAR:
      return initialState;

    default:
      return state;
  }
}